import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";
import { getOperatorsByJobtype } from "../../../services/userService";
interface Operator {
  id: number;
  username: string;
}

interface Props {
  value: number; // store operator ID
  onChange: (id: number) => void;
  onOperatorChange?: () => void; // New callback for resetting data
  jobtypeId?: number;
}

export const OperatorDropdown = ({
  value,
  onChange,
  onOperatorChange,
  jobtypeId,
}: Props) => {
  const [operators, setOperators] = useState<Operator[]>([]);

  useEffect(() => {
    const id = jobtypeId ?? 3;
    getOperatorsByJobtype(id).then(setOperators).catch(console.error);
  }, [jobtypeId]);

  const handleChange = (newValue: number) => {
    onChange(newValue);
    // Call the reset callback if provided
    if (onOperatorChange) {
      onOperatorChange();
    }
  };

  return (
    <FormControl sx={{ width: "20%" }}>
      <InputLabel>Operator</InputLabel>
      <Select
        value={value}
        label="Operator"
        onChange={(e) => handleChange(Number(e.target.value))}
      >
        {operators.map((op) => (
          <MenuItem key={op.id} value={op.id}>
            {op.username}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default OperatorDropdown;
